import { Component, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/api/profile.service';
import { Router } from '@angular/router';

@Component({
    selector: 'auth-no-wallet',
    templateUrl: './no-wallet.component.html',
    styleUrls: ['./no-wallet.component.scss'],
    standalone: false
})
export class NoWalletComponent implements OnInit {

  constructor(private router: Router, private profileService: ProfileService ) { }

  ngOnInit() {
    this.profileService.getGeneral().subscribe(response => {
      if (response.hasWallet) {
        this.router.navigate(['/dashboard']);
      }
    });
  }

}
